import UploadDocuments from "@/shared/components/common/uploadDocuments";
import BoxKit from "@/shared/components/kit/box";
import { Grid, TextField } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
interface ThirdRadioProps {
  setFreelanceJob: any;
  setUploadImageJob: Dispatch<SetStateAction<any>>;
  setUploadImageElseJob: Dispatch<SetStateAction<any>>;
}
/**
 * ThirdRadio
 *
 * کامپوننتی برای وارد کردن اطلاعات شغلی کاربران صاحب مشاغل آزاد.
 * شامل فیلدهای زیر:
 * - نام شرکت
 * - سمت شغلی
 * - کد پستی شرکت
 * - شناسه ملی شرکت
 * - آدرس محل کار
 * همچنین امکان بارگذاری تصاویر اجاره‌نامه/سند کسب و کار و جواز کسب فراهم شده است.
 *
 * @param {Object} props
 * @param {Function} props.setFreelanceJob تابع برای بروزرسانی اطلاعات شغل آزاد
 * @param {Dispatch<SetStateAction<any>>} props.setUploadImageJob تابع برای بارگذاری تصویر اجاره‌نامه/سند کسب و کار
 * @param {Dispatch<SetStateAction<any>>} props.setUploadImageElseJob تابع برای بارگذاری تصویر جواز کسب
 *
 * @component
 * @returns JSX.Element
 */

const ThirdRadio = ({ setFreelanceJob, setUploadImageJob, setUploadImageElseJob, }: ThirdRadioProps) => {

  const handleChangeForm =
    (field: any) => (event: React.ChangeEvent<HTMLInputElement>) => {
      setFreelanceJob((prev: any) => ({
        ...prev,
        [field]: event.target.value,
      }));
    };

  return (
    <BoxKit sx={{padding: 4,borderRadius: 2,width: "100%",margin: "auto",color: "white",}}>
      <Grid container spacing={2} component="div">
        <Grid size={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Grid size={6} component="div">
            <TextField
              fullWidth
              label="نام شرکت"
              variant="filled"
              onChange={handleChangeForm("company_name")}
              InputLabelProps={{ style: { color: "#ccc" } }}
              InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            />
          </Grid>
        </Grid>
        <Grid size={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Grid size={6} component="div">
            <TextField
              fullWidth
              label="سمت شغلی"
              onChange={handleChangeForm("company_title")}
              variant="filled"
              InputLabelProps={{ style: { color: "#ccc", width: "50%" } }}
              InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            />
          </Grid>
        </Grid>
        <Grid size={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Grid size={6} component="div">
            <TextField
              fullWidth
              onChange={handleChangeForm("postal_code")}
              label="کد پستی شرکت"
              variant="filled"
              InputLabelProps={{ style: { color: "#ccc" } }}
              InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            />
          </Grid>
        </Grid>
        <Grid size={12} sx={{ display: "flex", justifyContent: "center" }}>
          <Grid size={6} component="div">
            <TextField
              fullWidth
              label="شناسه ملی شرکت"
              variant="filled"
              onChange={handleChangeForm("company_nid")}
              InputLabelProps={{ style: { color: "#ccc" } }}
              InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
            />
          </Grid>
        </Grid>
        <Grid size={12} component="div">
          <TextField
            fullWidth
            label="آدرس محل کار"
            variant="filled"
            onChange={handleChangeForm("company_address")}
            InputLabelProps={{ style: { color: "#ccc" } }}
            InputProps={{style: {backgroundColor: "#1c1c1c",color: "white",borderRadius: 8,},}}
          />
        </Grid>
        <Grid size={12} component="div" sx={{width: "100%",display: "flex",justifyContent: "space-around",alignItems: "center",}}>
          <UploadDocuments label="بارگذاری عکس اجاره نامه یا سند کسب وکار" defaultImage={"./Legal-advice.png"} onUpload={(file: any) => setUploadImageJob(file)}/>
          <UploadDocuments label="بارگذاری عکس جواز کسب" defaultImage={"./Legal-advice.png"} onUpload={(file: any) => setUploadImageElseJob(file)}/>
        </Grid>
      </Grid>
    </BoxKit>
  );
};

export default ThirdRadio;
